import './index.less'

export default class MembershipNoActivity {
  constructor() {
    this.DOM = document.querySelector('[data-membership-no-activity]')

    if (this.DOM) {
      this.observe()
    }
  }

  observe() {
    const Observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('active')
        }
      })
    }, {
      root: null,
      rootMargin: '0px',
      threshold: 0,
    })

    const parentDOM = this.DOM
    const targetDOMs = parentDOM.querySelectorAll('[data-animation-dom]')
    if (targetDOMs.length > 0) {
      targetDOMs.forEach(item => Observer.observe(item))
    }
  }
}
